export default __webpack_public_path__ + "assets/home1.409e4b20.png";